<template>
    <div id="listBill">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title venderinvoice">  Vendor Invoice List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <!-- Comment due to various Vendor Invoice Type -->
                      <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="pdfPrint()" >
                        <i class="fp-print"></i> Print
                      </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openApprovedInvoicesModal()" >
                            <i class="fp-import"></i> Approve Invoices
                        </a>
                        <a v-if="sendInvButton" href="javascript:void(0)" class="btn btn-secondary" v-on:click="sendInvoices()">
                            Send Remittance
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportLineItemCheck()">
                              <i class="fp-export"></i> Export Line Item
                        </a>
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'ConformBillList'}"> Confirm Invoice </router-link>

                        <router-link v-if="canAddinvoice" class="btn btn-primary" v-bind:to="{name: 'BillCreate'}"> <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-invoice-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getEnteredVendorInvoices" v-on:click="getEnteredVendorInvoices(this)" :class="'btn btn-secondary '+ enteredActive"> Entered <span> {{ enteredCount }} </span> </button>
                                    <button type="button" id="getVerifiedVendorInvoices" v-on:click="getVerifiedVendorInvoices(this)" :class="'btn btn-secondary '+ verifiedActive"> Verified <span> {{ verifiedCount }} </span> </button>
                                    <button type="button" id="getApprovedVendorInvoices" v-on:click="getApprovedVendorInvoices(this)" :class="'btn btn-secondary '+ approvedActive"> Approved <span> {{ approvedCount }}</span> </button>
                                    <button type="button" id="getPaidVendorInvoices" v-on:click="getPaidVendorInvoices(this)" :class="'btn btn-secondary '+ paidActive"> Paid <span> {{ paidCount }}</span> </button>
                                    <button type="button" id="getDeletedVendorInvoices" v-on:click="getDeletedVendorInvoices(this)" :class="'btn btn-secondary '+ deletedActive"> Deleted <span> {{ deletedCount }}</span> </button>
                                    <button type="button" id="getAllVendorInvoices" v-on:click="getAllVendorInvoices(this)" :class="'btn btn-secondary '+ allActive"> All <span> {{ allCount }} </span> </button>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'billList'" ref="filterBill" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="importBatchProcess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} is processing. Please wait while we import vendor invoice !!</p>
                        <p v-if="remittanceBatchProcess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} is processing. Please wait while we Send Remittance !!</p>
                        <p v-if="statusBatchProcess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} is processing. Please wait while we change vendor invoice status !!</p>
                        <p v-if="batchSuccess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} has processed !!</p>
                        <p v-if="errorFound" id="importInvErrorMsg" class="alert-success p-2">Current batch {{importBatchNum}} processed.<router-link class="color-blue" v-bind:to="errorLink" target="_blank" @click.native="errorLink = '';errorFound = false;"> Click Here</router-link> to check import error!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section :class="'ml-0 bg-white '+ newWidth">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'billList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listBillTable"
                                    mode="remote"
                                    title="Vendor Invoice"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'bottom',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: flag != 'deleted' ? true : false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows" v-if="flag != 'deleted'">
                                        <div :key="key">
                                            <template v-if="props.column.field == 'action'">
                                                <template v-if="props.row.voucher_type.toLowerCase() == 'sublet_invoice'">
                                                    <template v-if="props.row.wo_status != null && ( props.row.wo_status.toLowerCase() != 'closed' && props.row.wo_status.toLowerCase() != 'approved') ">
                                                        <router-link v-if="canUpdateinvoice && props.row.status.toLowerCase() == 'entered'" title="Edit Vendor Invoice" class="fp-edit" v-bind:to="{name: 'BillEdit',params:{id:props.row.id,inv_type:props.row.type}}"></router-link>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <router-link v-if="((canUpdateinvoice && props.row.status.toLowerCase() == 'entered') || (updateVerifiedInvoice && props.row.status.toLowerCase() == 'verified' ) || (updateVerifiedInvoice && props.row.status.toLowerCase() == 'approved' )) && props.row.type != 'debt_note'" title="Edit Vendor Invoice" class="fp-edit" v-bind:to="{name: 'BillEdit',params:{id:props.row.id,inv_type:props.row.type}}"></router-link>
                                                </template>
                                            </template>
                                            <template v-else-if="props.column.field == 'bill_number'">
                                                <template v-if="props.row.is_file_uploaded == 1">
                                                    <template v-if="canViewinvoice">
                                                        <a href="javascript:void(0);" class="color-blue" v-on:click="openInvoicePreviewTab(props.row.id,$event)">{{props.row.bill_number}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{props.row.bill_number}}</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.bill_number}}</span>
                                                </template>
                                            </template>
                                            <template v-else-if="props.column.field == 'voucher_number'">
                                                <template v-if="canViewinvoice">
                                                    <router-link title="View Vendor Invoice" class="color-blue" v-bind:to="{name: 'BillView',params:{id:props.row.id}}">{{props.row.voucher_number}}</router-link>
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.voucher_number}}</span>
                                                </template>
                                            </template>
                                            <template v-else-if="props.column.field == 'po_number'">
                                                <template v-if="canViewPO">
                                                    <router-link title="View Vendor PO" class="color-blue" v-bind:to="{name: 'VendorPurchaseOrderView',params:{id:props.row.vendor_po_id},query:{fromUrl:frmUrl}}">{{props.row.po_number}}</router-link>
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.voucher_number}}</span>
                                                </template>
                                            </template>
                                            <template v-else-if="props.column.field == 'work_order_no'">
                                                <template v-if="canViewWO">
                                                    <router-link title="View WO" class="color-blue" v-bind:to="{name: 'WorkOrderView',params:{id:props.row.work_order_id},query:{fromUrl:frmUrl}}">{{props.row.work_order_no}}</router-link>
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.voucher_number}}</span>
                                                </template>
                                            </template>
                                            <template v-else-if="props.column.field == 'payment_no'">
                                                <a href="javascript:void(0)" title="View Check" v-on:click="openCheckPreview(props.row.payment_status,props.row.payment_id,null,props.row.pay_type)" class="color-blue" >
                                                    <template v-if="props.row.payment_status && props.row.payment_status.toLowerCase() == 'pending'">
                                                        View
                                                    </template>
                                                    <template v-else>
                                                        {{props.row.check_no}}
                                                    </template>
                                                    <!-- {{props.row.payment_no}} -->
                                                </a>
                                            </template>
                                            <template v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </template>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions" v-if="flag != 'deleted'">
                                        <button id="changeAssigneeBtn" v-on:click.prevent="showAssigneeModal" class="btn btn-primary">Change Assignee / Payment Type</button>
                                        <template v-if="flag == 'all'">
                                            <!-- <button v-if="canMakeInvoicePayment == true && showPaymentBtn === true" id="makePaymentBtn" v-on:click.prevent="makePayment" class="btn btn-primary">Make Payment</button> -->
                                            <!-- <button v-if="canMakeInvoicePayment == true && bool_approve === true" id="makePaymentBtn" v-on:click.prevent="confirmStatus('allTab','makePayment','approved')" class="btn btn-primary">Make Payment</button> -->

                                            <!--template v-else-if="displayConfirmBtn"-->
                                            <!--button v-if="displayConfirmBtn == true" type="button" class="btn btn-primary" id="verifyStatusBtnPreview" v-on:click="confirmInvoiceStatus('confirmed')">Confirm</button-->
                                            <!--button v-if="displayPrintBtn == true" type="button" class="btn btn-primary" id="verifyStatusBtnPreview" v-on:click="print('print_payment_cheque')">Print</button-->
                                            <!--button v-if="displayResetBtn == true" type="button" class="btn btn-primary" id="verifyStatusBtnPreview" v-on:click="reset()">Reset</button-->
                    <!--/template-->

                                            <!-- <template v-if="selectedStatus == 'entered' && canVerify"> -->
                                              <template v-if="bool_enter === true && canVerify">
                                                <button type="button" class="btn btn-primary" v-on:click="confirmStatus('allTab','verified','entered')">Verify</button>
                                            </template>
                                            <!-- <template v-else-if="selectedStatus == 'verified' && (canApprove || canVerify)"> -->
                                            <template v-if="bool === true && (canApprove || canVerify)">
                                              <button type="button" id="unverifyStatusBtn" v-on:click="confirmStatus('allTab','entered','verified')" class="btn btn-secondary">Unverify</button>
                                              <button type="button" class="btn btn-secondary" id="approveStatusBtnAll" v-on:click="confirmStatus('allTab','approved','')">Approve</button>
                                              <button type="button" class="btn btn-secondary" id="voidStatusBtnAll" v-on:click="confirmStatus('allTab','void','entered')">Void</button>
                                            </template>
                                              <template v-if="bool_verify === true && (canApprove || canVerify)">
                                                <button v-if="canVerify" type="button" id="unverifyStatusBtn" v-on:click="confirmStatus('allTab','entered','verified')" class="btn btn-secondary">Unverify</button>
                                                <button v-if="canApprove" type="button" class="btn btn-secondary" id="approveStatusBtnAll" v-on:click="confirmStatus('allTab','approved','verified')">Approve</button>
                                            </template>
                                            <!-- <template v-else-if="selectedStatus == 'disapproved' && canApprove"> -->
                                              <template v-if="bool_disapprove === true && canApprove">
                                                <!-- <button type="button" class="btn btn-secondary" id="approveStatusBtnAll" v-on:click="confirmStatus('allTab','approved','entered')">Approve</button> -->
                                                <button type="button" class="btn btn-secondary" id="voidStatusBtnAll" v-on:click="confirmStatus('allTab','void','entered')">Void</button>
                                            </template>
                                            <!-- <template v-else-if="selectedStatus == 'approved' && canApprove"> -->
                                              <template v-if="bool_approve === true && canApprove">
                                                <button v-if="canVerify" type="button" id="unverifyStatusBtn" v-on:click="confirmStatus('allTab','entered','verified')" class="btn btn-secondary">Unverify</button>
                                                <!-- <button v-if="canApprove" type="button" class="btn btn-secondary" id="disapproveStatusBtnAll" v-on:click="confirmStatus('allTab','disapproved','approved')">Disapprove</button> -->
                                            </template>
                                        </template>
                                        <template v-else-if="flag == 'entered'">
                                            <button type="button" class="btn btn-primary" v-on:click="confirmStatus('allTab','verified','entered')">Verify</button>
                                        </template>
                                        <template v-else-if="flag == 'verified'">
                                            <button v-if="canVerify" id="unverifyStatusBtn" v-on:click="confirmStatus('verifyTab','entered','verified')" class="btn btn-secondary">Unverify</button>
                                            <button v-if="canApprove" id="approveStatusBtn" v-on:click="confirmStatus('verifyTab','approved','verified')" class="btn btn-secondary">Approve</button>
                                        </template>
                                        <template v-else>
                                            <!-- <button v-if="canMakeInvoicePayment == true && showPaymentBtn === true" id="makePaymentBtn" v-on:click.prevent="makePayment" class="btn btn-primary">Make Payment</button> -->
                                            <!-- <button v-if="canMakeInvoicePayment == true && bool_approve === true" id="makePaymentBtn" v-on:click.prevent="confirmStatus('allTab','makePayment','approved')" class="btn btn-primary">Make Payment</button> -->
                                            <!-- <button v-if="canApprove" id="disapproveStatusBtn" v-on:click="confirmStatus('verifyTab','disapproved','approved')" class="btn btn-secondary">Disapprove</button> -->
                                            <button v-if="canVerify" type="button" id="unverifyStatusBtn" v-on:click="confirmStatus('allTab','entered','verified')" class="btn btn-secondary">Unverify</button>
                                        </template>
                                        <button v-if="canRemoveinvoice" id="deleteBillBtn" v-on:click.prevent="conforminvoice()" class="btn btn-secondary">Add Confirm Invoice</button>
                                        <button v-if="canRemoveinvoice" id="deleteBillBtn" v-on:click.prevent="billDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>

                        </div>

                        <div class="modal fade" id="voucher-view-modal" ref="voucherViewModal" data-backdrop="static" data-keyboard="false" aria-labelledby="voucherViewModal" aria-hidden="false">
                            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Voucher Invoice View</h5>
                                        <button type="button" class="close" id="btnModalClose" v-on:click="hideVInvViewModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <vendor-invoice-preview v-if="showPreview" :moduleName="'billList'" :vendorInvoiceId="vendorInvoiceId" :permissions="vendorInvPermission">
                                        </vendor-invoice-preview>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                      <div class="modal fade" id="print-pdf-modal" ref="printPdfModal" data-backdrop="static" data-keyboard="false" aria-labelledby="printPdfModal" aria-hidden="false">-->
<!--                        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">-->
<!--                          <div class="modal-content">-->
<!--                            <div class="modal-header">-->
<!--                              <h5 class="modal-title">Print Pdf View</h5>-->
<!--                              <button type="button" class="close" id="btnModalClose" v-on:click="hidePrintPdfModel()">&times;</button>-->
<!--                            </div>-->
<!--                            <div class="modal-body">-->
<!--                              <pdfPrintPreview v-if="showPreview" :moduleName="'printPdfModal'" :vendorInvoiceId="vendorInvoiceId">-->
<!--                              </pdfPrintPreview>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->

                        <div class="modal fade change-status-modal" id="change-status-modal" ref="changeStatusModal" data-backdrop="static" data-keyboard="false" aria-labelledby="changeStatusModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select Status</h5>
                                        <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <template v-if="selectedStatus == 'entered' && canVerify">
                                            <button type="button" class="btn btn-primary" id="verifyStatusBtn" v-on:click="confirmStatus('modal','verified')">Verify</button>
                                        </template>
                                        <template v-else-if="selectedStatus == 'verified' && canApprove">
                                            <button type="button" class="btn btn-secondary" id="approveStatusBtn" v-on:click="confirmStatus('modal','approved')">Approve</button>
                                            <button type="button" class="btn btn-secondary" id="disapproveStatusBtn" v-on:click="confirmStatus('modal','disapproved')">Disapprove</button>
                                            <p class="field-error" v-show="statusError">You can only process those invoice which are verified by other.</p>
                                            <p v-show="statusError">Following invoices have been verified by you : </p>
                                            <template v-if="statusApprovedArr.length">
                                                <template v-for="(inv,key) in statusApprovedArr">
                                                    <a :key="key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="key"> {{inv}}</span>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else-if="selectedStatus == 'disapproved' && canApprove">
                                            <button type="button" class="btn btn-secondary" id="approveStatusBtn" v-on:click="confirmStatus('modal','approved')">Approve</button>
                                            <button type="button" class="btn btn-secondary" id="voidStatusBtn" v-on:click="confirmStatus('modal','void')">Void</button>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade make-payment-modal" id="make-payment-modal" ref="makePaymentModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Make Payment</h5>
                                        <button type="button" class="close" id="btnPaymentModalClose" v-on:click="hidePaymentModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <div class="col-sm-6 form-group">
                                                <label class="control-label"  for="payment_type">Payment Type:</label>
                                                <v-select class="close-remove" v-model="payment_type" name="payment_type" placeholder="Select Payment Type." label="text" :options="paymentTypesArr" :disabled="true">
                                                </v-select>
                                                <div class="field-error">{{payment_type_error_msg}}</div>
                                            </div>
                                            <div class="col-sm-6 form-group">
                                                <label class="control-label require" for="payment_date">Payment Date:</label>
                                                <div class="input-group">
                                                    <date-picker placeholder="MM/DD/YYYY" id="payment_date" name="payment_date" v-model="payment_date" :config="optionsDate"></date-picker>
                                                    <label for="payment_date" class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{ payment_date_error_msg }}</div>
                                            </div>
                                            <template v-if="showTagSearchField">
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="payment_tag"> Tag:</label>
                                                    <v-select v-model="payment_tag" name="payment_tag"
                                                        label="text" :filterable="false" :options="paymentTagsArr"
                                                        @search="onSearchPaymentTag"
                                                        placeholder="Select Tag" class="custom-ci-auto-search">
                                                        <template slot="no-options">
                                                            Search Tag...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                                <div class="col-sm-3 form-group mt-4">
                                                    <label class="control-label">&nbsp;</label>
                                                    <button class="btn btn-primary" id="btnAddTagModal" v-on:click="showTagInput()"><i class="fp-add"> </i> Tag </button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="tag_input"> Tag Name:</label>
                                                    <input type="text" class="form-control" v-model="tag_input" id="tag_input" placeholder="Enter Tag Name" name="tag_input">
                                                    <div class="field-error">{{tag_input_error_msg}}</div>
                                                </div>
                                                <div class="col-sm-3 form-group mt-4">
                                                    <label class="control-label">&nbsp;</label>
                                                    <button class="btn btn-primary" id="btnSaveTagModal" v-on:click="savePaymentTag()"><i class="fp-save"></i> Save </button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 form-group">
                                        <label class="control-label" for="tag_input"> Next Check#:  {{ check_number }}</label>
                                    </div>
                                    <div class="modal-footer">

                                        <button class="btn btn-primary" id="btnPaymentModalProcess" v-on:click="processPayment()"> Process </button>
                                        <button class="btn btn-tertiary" id="btnPaymentModalCancel" v-on:click="hidePaymentModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade seperate-message-modal" id="seperate-message-modal" ref="seperateMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="seperateMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="color-red" v-show="statusMessageError">You can only process those invoice which are verified by other.</p>
                                        <p v-show="statusMessageError">Following invoice(s) has been verified by you : </p>
                                        <template v-if="statusMessageApprovedArr.length">
                                            <template v-for="(inv,key) in statusMessageApprovedArr">
                                                <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{inv}}</span>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade work-order-message-modal" id="work-order-message-modal" ref="workOrderMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="workOrderMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideWOMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="color-red" v-show="woClosedMessageError">Following invoice(s) already attached to Line Item of Work Order : </p>
                                        <template v-if="woClosedMessageArr.length">
                                            <template v-for="(woClosed,index) in woClosedMessageArr">
                                                <template v-if="woClosed.invoice_no != undefined && woClosed.invoice_no != null">
                                                    <p :key="index">#Invoice : {{woClosed.invoice_no}}&nbsp;&nbsp;
                                                        <template v-if="woClosed.wo_no != undefined && woClosed.wo_no != null">
                                                            - #Work Order : {{woClosed.wo_no}}&nbsp;&nbsp;
                                                        </template>
                                                    </p>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade sub-system-message-modal" id="sub-system-message-modal" ref="subSystemMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="subSystemMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalMessageSubClose" v-on:click="hideSubSystemMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="color-red" v-show="subSystemClosedMsgError">Subsystem A/P DIRECT ENTRY has been closed.</p>
                                        <p v-show="subSystemClosedMsgError">Following invoice(s) cannot be approved : </p>
                                        <template v-if="subSystemClosedMsgArr.length">
                                            <template v-for="(inv,key) in subSystemClosedMsgArr">
                                                <a :key="'isub' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'jsub' + key"> {{inv}}</span>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade doc-required-message-modal" id="doc-required-message-modal" ref="docRequiredMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="docRequiredMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalMessageDocRequire" v-on:click="hideDocRequireModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p v-show="docRequiredMsgError">Following invoice(s) cannot be verified as document upload required : </p>
                                        <template v-if="docRequiredMsgArr.length">
                                            <template v-for="(inv,key) in docRequiredMsgArr">
                                                <a :key="'isub' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'jsub' + key"> {{inv}}</span>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade invoice-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col-md-12">
                                                    <label class="control-label require" for="name">File:</label>
                                                    <input class="font-1" id="typeImage" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{selectedFileErrorMsg}}</div>
                                                </div>
                                                <div class="col-md-12 mt-4" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file for Invoice </label><br/>
                                                    <a href="javascript:void(0)" class="color-blue font-1" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>
                                            <template v-if="duplicateInvoice && duplicateInvoice.length > 0">
                                                <label>{{duplicateInvCount}} Invoice(s) already exist:</label>
                                                <template v-for="(inv,perKey) in duplicateInvoice">
                                                    <a :key="perKey" v-if="perKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perKey">{{inv}}</span>
                                                </template>
                                            </template>
                                            <template v-if="dateIssueInvoice && dateIssueInvoice.length > 0">
                                                <label>{{dateIssueCount}} Invoice(s) Not Imported Because Invoice Date is not given:</label>
                                                <template v-for="(date,assetKey) in dateIssueInvoice">
                                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{date}}</span>
                                                </template>
                                            </template>
                                            <template v-if="withoutVendorInvoice && withoutVendorInvoice.length > 0">
                                                <label>{{withoutVendorCount}} Invoice(s) Not Imported Because Vendor Not Available:</label>
                                                <template v-for="(vendor,ptKey) in withoutVendorInvoice">
                                                    <a :key="ptKey" v-if="ptKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="ptKey">{{vendor}}</span>
                                                </template>
                                            </template>
                                            <template v-if="dateValidateInvoice && dateValidateInvoice.length > 0">
                                                <label>{{dateValidateCount}} Invoice(s) Not Imported Because Due Date Is Earlier Than Invoice Date:</label>
                                                <template v-for="(vd,ptiKey) in dateValidateInvoice">
                                                    <a :key="ptiKey" v-if="ptiKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="ptiKey">{{vd}}</span>
                                                </template>
                                            </template>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                        <button class="btn btn-primary" id="myButton" v-on:click="importBill()"> <i class="fp-import"> </i> Import</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade change-assignee-modal" id="change-assignee-modal" ref="changeAssigneeModal" data-backdrop="static" data-keyboard="false" aria-labelledby="changeAssigneeModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Change Assignee / Payment Type</h5>
                                        <button type="button" class="close" id="btnAssigneeModalClose" v-on:click="hideAssigneeModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <div class="col-sm-6 form-group">
                                                <label class="control-label" for="change_assignee">Assignee:</label>
                                                <v-select v-model="change_assignee" name="change_assignee" label="text" :filterable="false" :options="assigneeArr" @search="onSearchAssignee" placeholder="Select Assignee Code or Name" class="custom-ci-auto-search">
                                                    <template slot="no-options">
                                                        Search Assignee Code or Name...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="field-error">{{assignee_error_msg}}</div>
                                            </div>

                                            <div class="col-sm-6 form-group">
                                                <label class="control-label" for="change_paymenttype">Payment Type:</label>
                                                <v-select v-model="change_paymenttype" name="change_paymenttype" placeholder="Select Payment Type."
                                                        label="text"
                                                        :options="paymenttypeArr">
                                                </v-select>
                                                <!--v-select v-model="change_paymenttype" name="change_paymenttype" label="text" :filterable="false" :options="paymenttypeArr" @search="onSearchAssignee" placeholder="Select Assignee Code or Name" class="custom-ci-auto-search">
                                                    <template slot="no-options">
                                                        Search Payment Type...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select-->
                                                <div class="field-error">{{paymenttype_error_msg}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="btnAssigneeModalUpdate" v-on:click="changeAssignee()"> Update </button>
                                        <button class="btn btn-tertiary" id="btnAssigneeModalCancel" v-on:click="hideAssigneeModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade approved-invoice-modal" id="myapprovedModal" ref="myapprovedModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select Approved Invoice File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col-md-12">
                                                    <label class="control-label require" for="name">File:</label>
                                                    <input class="font-1" id="type_Image" type="file" @change="oninviceFileChanged">
                                                    <div class="field-error">{{selectedapproveFileErrorMsg}}</div>
                                                </div>
                                                <div class="col-md-12 mt-4" v-if="file_Name != ''">
                                                    <label class="control-label"> Download Sample file for Approved Invoice </label><br/>
                                                    <a href="javascript:void(0)" class="color-blue font-1" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{file_Name}} </a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                        <button class="btn btn-primary" id="myapproveButton" v-on:click="importApprovedInvoices()"> <i class="fp-import"> </i> Import</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade approved-invoice-modal" id="validationModal" ref="validationModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-scrollable" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">Invalid Vendor Invoices</h5>
                              </div>
                              <div class="modal-body">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                  <thead>
                                    <tr class="table-primary">
                                      <th scope="col" class="w-10 require">SN</th>
                                      <th scope="col" class="w-45 require">Invoice Number</th>
                                      <th scope="col" class="w-45 require">Reason</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-for="(data, sn) in invalid_data">
                                      <tr>
                                        <td>{{sn + 1}}</td>
                                        <td>{{data.invoice}}</td>
                                        <td>{{data.reason}}</td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </table>
                              </div>
                              <div class="modal-footer">
                                <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Ok</button>
                              </div>
                          </div>
                          </div>
                        </div>
                        <div class="modal fade" id="vendor-view-modal" ref="vendorViewModal" data-backdrop="static" data-keyboard="false" aria-labelledby="vendorViewModal" aria-hidden="false">
                            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Vendor Invoice </h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <label class="control-label"><b>Emails Are Missing For Following Vendors:</b></label><br />
                                            <template v-for="(data,key) in invArr">
                                                <span class="control-label" for="tag_input">{{ data.vendorname }}</span><span v-if="key+1 < invArr.length">&nbsp; , &nbsp;</span>
                                            </template>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                        <button class="btn btn-primary" id="okbutton" data-dismiss="modal" v-on:click="sendInvoices('done')"> Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="field-error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="right-invoice-tab-list workorder-right-sidebar invoice-list-sidebar" id="invoice-detail-section">
            <div class="containerTab">
                <a href="javascript:void(0)" class="closebtn" v-on:click="closeInvoicePreview()">×</a>
                <div class="content">
                    <div class="col-sm-6 status-btn-space">
                    <template v-if="selectedStatus == 'entered' && canVerify">
                        <button type="button" class="btn btn-primary pull-left" id="verifyStatusBtnPreview" v-on:click="confirmStatus('preview','verified')">Verify</button>
                    </template>
                    <template v-else-if="selectedStatus == 'verified' && canApprove">
                        <template v-if="!isVerifiedBy">
                            <button type="button" class="btn btn-primary pull-left" id="approveStatusBtnPreview" v-on:click="confirmStatus('preview','approved')">Approve</button>
                            <button type="button" class="btn btn-primary pull-left status-btn-left" id="disapproveStatusBtnPreview" v-on:click="confirmStatus('preview','disapproved')">Disapprove</button>
                        </template>
                        <template v-else>
                            <p class="field-error">You can only approve those invoice which are verified by other.</p>
                        </template>
                    </template>
                    <template v-else-if="selectedStatus == 'disapproved' && canApprove">
                        <template v-if="!isVerifiedBy">
                            <button type="button" class="btn btn-primary pull-left" id="approveStatusBtnPreview" v-on:click="confirmStatus('preview','approved')">Approve</button>
                            <button type="button" class="btn btn-primary pull-left status-btn-left" id="voidStatusBtnPreview" v-on:click="confirmStatus('preview','void')">Void</button>
                        </template>
                        <template v-else>
                            <p class="d-field-error">You can only approve those invoice which are verified by other.</p>
                        </template>
                    </template>
                    </div>
                    <div class="clearfix"></div>
                    <template v-if="extension == 'pdf'">
                        <iframe :src="path" title="" width="95%" height="500px" id="invoicePreview"></iframe>
                    </template>
                    <template v-else>
                        <img :src="path" id="invoicePreview" width="95%" height="435px" alt="Vendor Invoice Preview"/>
                    </template>
                </div>
            </div>
        </div>

        <div class="invoice-view-table" id="print_payment_cheque">
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);

import EventBus from ".././event-bus";
var contex

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
let msgServer;

export default {
    name: "BillList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Vendor Invoice List | " +process.env.COPYRIGHT_NAME
    },
    components: {


        vendorInvoicePreview: () => import('@/components/accounting/VendorInvoicePreview'),
        pdfPrintPreview: () => import('@/components/accounting/PdfPrintPreview'),

    },
    mixins:[commonMixins,dataTableMixins,contractMixins],
    data: () => ({
        pageKey: '_vendor_invoice_list_',
        batchProcess:0,
        batchNum:"",
        firstLoad : 0,
        userColumns:[],
        check_number: '',
        ach_check_number: '',
        checknumber: '',
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false
            },
            {
                label: 'Invoice',
                field: 'bill_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Bill", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Voucher',
                field: 'voucher_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Voucher", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
          {
            label: 'Voucher Type',
            field: 'voucher_type',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
          },
            {
                label: 'Vendor PO',
                field: 'po_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "#Vendor PO", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: '#Work Order',
                field: 'work_order_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "#Vendor PO", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Payment#',
                field: 'payment_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment#", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Payment Type',
                field: 'payment_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Type", // placeholder for filter input
                    filterDropdownItems: ['ACH', 'CHECK','COMCHECK','CREDIT CARD'],
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Payment Date',
                field: 'payment_date',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vendor',
                field: 'vendor',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'vendoremail',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Location',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Amount",
                field: "amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                    label: 'Invoice Date',
                    field: 'bill_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Due Date',
                    field: 'due_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Invoice Add Date',
                    field: 'invoice_add_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assignee',
                    field: 'vendor_assignee_id',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assignee", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Verified By',
                    field: 'verified_by_name',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Verified By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Approved By',
                    field: 'approved_by_name',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Approved By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: 'Approved At',
                    field: 'approved_at',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Approved By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Monthly Payable',
                    field: 'monthly_payable',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Monthly Payable", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Yes","No"]
                    }
                },
                {
                    label: "Post Month",
                    field: "post_month",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Post Month", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Post Year",
                    field: "post_year",
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Post Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Settled",
                    field: "is_settled",
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Post Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        cantAccessPage:"",
        bill_value:false,
        selectedStatus:"",
        vendorInvoiceIdArr:[],
        statusArr:[
            {text:'Entered',value:'entered'},
            {text:'Verified',value:'verified'},
            {text:'Approved',value:'approved'},
            {text:'Paid',value:'paid'},
            {text:'Void',value:'void'},
        ],
        path:"",
        loggedInUser:0,
        isNotVerifiedBy:false,
        isVerifiedBy:false,
        // displayConfirmBtn:false,
        // displayPrintBtn:false,
        // displayResetBtn:false,
        sendInvButton:false,
        hideButton:false,
        canVerify:false,
        canApprove:false,
        showPaymentBtn:false,
        payment_type:"",
        payment_type_error_msg:"",
        paymentTypesArr:[],
        statusError:false,
        canAddinvoice:false,
        canUpdateinvoice:false,
        canViewinvoice:false,
        canChangeStatus:false,
        canRemoveinvoice:false,
        statusApprovedArr:[],
        canMakeInvoicePayment:false,
        paymentTagsArr:[],
        payment_tag:"",
        showTagSearchField:true,
        tag_input:"",
        tag_input_error_msg:"",
        allActive:'',
        verifiedActive:'',
        approvedActive:'',
        enteredActive:'',
        deletedActive:'',
        paidActive:'',
        flag:'all',
        allCount:0,
        verifiedCount:0,
        approvedCount:0,
        enteredCount:0,
        deletedCount:0,
        paidCount:0,
        statusMessageError:false,
        statusMessageApprovedArr:[],
        extension:"",
        payment_date:"",
        payment_date_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        action:'list',
        fileName:'',
        file_Name:'',
        selectedBillFile:'',
        selectedapproveBillFile:'',
        withoutVendorInvoice:[],
        dateIssueInvoice:[],
        duplicateInvoice:[],
        selectedFileErrorMsg:"",
        selectedapproveFileErrorMsg:"",
        canViewPO:false,
        woClosedMessageError:false,
        woClosedMessageArr:[],
        newWidth:"",
        showPreview:false,
        vendorInvoiceId:"",
        updateVerifiedInvoice:false,
        frmUrl:"",
        ssArr:[],
        bool_enter:false,
        bool_verify:false,
        bool_approve:false,
        bool_disapprove:false,
        bool:false,
        subSystemClosedMsgError:false,
        subSystemClosedMsgArr:[],
        dateValidateInvoice:[],
        duplicateInvCount:0,
        dateIssueCount:0,
        withoutVendorCount:0,
        dateValidateCount:0,
        change_assignee:"",
        assigneeArr:[],
        assignee_error_msg:"",
        billIdArr:[],
        change_paymenttype: "",
        paymenttypeArr: [
            {
                value: "ACH",
                text: "ACH"
            },
            {
                value: "CHECK",
                text: "CHECK"
            },
            {
                value: "COMCHECK",
                text: "COMCHECK"
            },
            {
                value: "CREDIT CARD",
                text: "CREDIT CARD"
            },
        ],
        paymenttype_error_msg: "",
        canViewWO:false,
        importBatchProcess:false,
        remittanceBatchProcess:false,
        statusBatchProcess:false,
        importBatchNum:"",
        importBatchId:0,
        batchError:false,
        batchErrorMsg:"",
        errorLink:"",
        errorFound:false,
        docRequiredMsgError:false,
        docRequiredMsgArr:[],
        vendorInvPermission:[],
        invalid_data:[],
        invArr:[],
        batchSuccess : false
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_vendor_invoice') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'delete_vendor_invoice') {
                    self.bill_value = true;
                }
                if (permissions.name == 'can_verify_vendor_invoice') {
                    self.canVerify = true;
                }
                if (permissions.name == 'can_approve_vendor_invoice' || permissions.name == 'can_approve_sublet_invoice' ) {
                    self.canApprove = true;
                }
                if (permissions.name == 'add_vendor_invoice') {
                    self.canAddinvoice = true;
                    self.canUpdateinvoice = true;
                }
                if (permissions.name == 'view_vendor_invoice') {
                    self.canViewinvoice = true;
                }
                if (permissions.name == 'change_vendor_invoice_status') {
                    self.canChangeStatus = true;
                }
                if (permissions.name == 'delete_vendor_invoice') {
                    self.canRemoveinvoice = true;
                }
                if (permissions.name == 'make_vendor_payment') {
                    self.canMakeInvoicePayment = true;
                }
                if (permissions.name == 'view_purchase_order') {
                    self.canViewPO = true;
                }
                if (permissions.name == 'list_work_order') {
                    self.canViewWO = true;
                }
                if (permissions.name == 'update_verified_vendor_invoice') {
                    self.updateVerifiedInvoice = true;
                }



            });
        }
    },
    mounted: function () {

        this.getPermissions();

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     this.role = userObj.roles[0].name;

            // }
            if (userObj.id > 0) {
                this.loggedInUser = userObj.id;

            }
        }
        var self = this;
        this.frmUrl = btoa(window.location.pathname);
        self.loadFieldData(['vendorInvoicePaymentTypes']);
        // setTimeout(function() {
        //     self.allActive = 'active';
        // },1000);
         // when user came back from other page this will load the same tab selected before
         $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("bill_list_prev_tab");

            if ( prevSelectedTab == null ) {
                self.flag = "entered";
                self.enteredActive = 'active';
                localStorage.setItem('bill_list_prev_tab', 'entered');

            } else {

                if ( prevSelectedTab == 'verified' ) {

                    self.flag = "verified";
                    self.verifiedActive = 'active';

                } else if ( prevSelectedTab == 'approved' ) {

                    self.flag = "approved";
                    self.approvedActive = 'active';

                }else if(prevSelectedTab ==  'all'){

                    self.flag = "all";
                    self.allActive = 'active';

                }else if(prevSelectedTab == 'deleted'){
                    self.flag = 'deleted';
                    self.deletedActive = 'active';
                }else if(prevSelectedTab == 'paid'){
                    self.flag = 'paid';
                    self.paidActive = 'active';
                } else {

                    self.flag = "entered";
                    self.enteredActive = 'active';
                }
            }

            //Listen VendorInvoiceUpdateEvent to refresh invoice page
            var env = process.env.NODE_ENV;
            window.Echo.private(env+'-vendor-invoice-update').listen('VendorInvoiceUpdateEvent', (e) => {
                if(e.payload.is_invoice_updated == "1"){
                    self.loadList();
                }
            });

    },
    beforeMount: function() {
        contex = this;
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    methods: {

        cancelAll: function (cancelAll) {
          this.$refs.listBillTable.unselectAllInternal();
        },
        openCheckPreview(status,payment_id,file_path,check_type) {

            var self = this;
            var fromUrl = window.location.pathname;
            var url = '&payment_id='+payment_id+'&status='+status+'&type='+check_type+'&fromUrl='+fromUrl;
            self.$router.push({ name: 'VendorPaymentPreview', query: { data : btoa(url) }});
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listBillTable'].selectedRows;
            count = data.length;
            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }
            this.exportReports(actionFlag);
        },
      exportLineItemCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listBillTable'].selectedRows;
            count = data.length;
            if(count != 0 && count < 100){
              actionFlag = "export_line_item";
            }
            this.exportLineItemReports(actionFlag);
        },
      pdfPrint: function() {
        var data = this.$refs['listBillTable'].selectedRows;
        var ids = []
        for (var i = 0; i < data.length; i++) {
          ids.push(this.$refs['listBillTable'].selectedRows[i].id)
        }
        this.openPdfPrintTab(ids)
      },
      loadList: function() {
            var self = this;
            var data = this.$refs['listBillTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listBillTable'].selectedRows[i].id)
            }
           // check flag sendRemittance --AS
           var selectedCust;
            if(self.action =='sendRemittance') {
                var rowData = self.$refs['listBillTable'].selectedRows;
                for (var i = 0; i < rowData.length; i++) {
                        var invIdArr = [];
                        if(this.$refs['listBillTable'].selectedRows[i].vendoremail == null){
                            // self.invArr.push({vendorname: this.$refs['listBillTable'].selectedRows[i].vendor,vendor_id: this.$refs['listBillTable'].selectedRows[i].vendor_id})
                        }else{
                            invIdArr.push(this.$refs['listBillTable'].selectedRows[i].id)
                        }
                    }
                selectedCust=invIdArr;
            }


            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                flag:self.flag,
                all:self.serverParams.selectedAll,
                id:use,
                action:self.action,
                cust_id : selectedCust,
            };
            self.loading = true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/bill/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                success: function (data) {
                    self.loading = false;

                    // console.log(data);
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue" || self.action == "export_line_item" || self.action == "export_line_item_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" || self.action == "export_line_item" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            self.loadList();
                            return;

                        } else if(self.action == "sendRemittance") {
                            self.action = "list";

                            self.$refs.filterBill.clearSelectAll();
                            self.$swal('', 'Vendor Remittance Sent', 'success');
                            EventBus.$emit('clear-all-flags', false);
                            self.remittanceBatchProcess = true;
                            self.importBatchId = data.batch;
                            self.importBatchNum = data.batchNumber;
                            self.checkBatchStatus();
                            self.loadList();
                            return;
                        } else if ( self.action == "delete" ) {

                            self.action = "list";
                            self.$refs.filterBill.clearSelectAll();

                            var msg = "";

                            msg = data.content.deleted+" records have been deleted";

                            if ( data.content.skipped == 1 ) {
                                msg +=" and "+data.content.skipped+" record was approved so skipped that record";
                            } else if ( data.content.skipped > 1 ) {
                                msg +=" and "+data.content.skipped+" records were approved so skipped that records";
                            }
                            msg +=".";

                            self.$swal('',msg,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;

                        } else {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.checknumber = data.content.check;
                            self.ach_check_number = data.content.ach_check;
                        }

                        // self.filteredFlag = false;
                        // if(data.content.flag == "verified"){
                        //     self.verifiedCount = data.content.totalRecords;
                        // }else if (data.content.flag == "approved"){
                        //     self.approvedCount = data.content.totalRecords;
                        // }else if (data.content.flag == "entered"){
                        //     self.enteredCount = data.content.totalRecords;
                        // }else{
                        //     self.allCount = data.content.totalRecords;
                        // }
                        // self.filteredFlag = false;
                        // self.allCount = data.content.totalRecords;
                        // self.verifiedCount = data.content.totalRecords;
                        // self.approvedCount = data.content.totalRecords;
                        self.getcount();
                    }
                    //reset action to list so when send requset again it will consider as list


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.action = "list";
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-list');
                }
            });
        },
        billDelete() {

            //var data = this.$refs['listBillTable'].selectedRows;
            var self = this;
            self.$swal({
                    title: 'Are you sure that you want to delete this Vendor Invoice?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });
            // var use = [];
            // for (var i = 0; i < data.length; i++) {
            //     use.push(this.$refs['listBillTable'].selectedRows[i].id)
            // }

            // if (confirm('Are you sure that you want to delete this Vendor Invoice? ')) {
            //     self.action = 'delete';
            //     self.loadList();
                // self.loading = true;
                // $("#deleteBillBtn").val("Deleting ...");
                // $.ajax({
                //     url: process.env.ROOT_API + "/bill/delete",
                //     type: "POST",
                //     data: 'id=' + use,
                //     headers : this.ajxHeaders
                //     dataType: 'json',
                //     success: function (data) {
                //         self.loading = false;
                //         setTimeout(function () {
                //         $(".alert-success").removeClass("show");
                //             $(".alert-success").addClass("hide");
                //         }, 5000);
                //         setTimeout(function () {
                //             $("#deleteBillBtn").val("Delete");
                //         }, 10000);
                //         if (data.code == '200') {
                //             self.loadList();
                //         }
                //     },
                //     error: function (jqXHR, exception) {
                //         self.loading = false;
                //         self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-delete');
                //     }
                // });
            // }
        },
        changeStatus() {
            var self = this;
            var rowData = self.$refs['listBillTable'].selectedRows;
            self.vendorInvoiceIdArr = [];
            var statusArr = [];

            for(var i = 0;i < rowData.length; i++){
                self.vendorInvoiceIdArr.push(rowData[i].id);
                statusArr.push(rowData[i].status);
            }

            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(statusArr);

            if (found) {
                self.selectedStatus = statusArr[0].toLowerCase();

                if (self.selectedStatus == 'approved') {
                    self.selectedStatus = "";
                    self.vendorInvoiceIdArr = [];
                    self.$swal('',"Vendor Invoices with Approved status cannot be changed.",'info');
                }else if(self.selectedStatus == 'void') {
                    self.selectedStatus = "";
                    self.vendorInvoiceIdArr = [];
                    self.$swal('',"Vendor Invoices with Void status cannot be changed.",'info');
                }else if(self.selectedStatus == 'in progress') {
                    self.selectedStatus = "";
                    self.vendorInvoiceIdArr = [];
                    self.$swal('',"Vendor Invoices with In Progress status cannot be changed.",'info');
                }else{
                    $("#change-status-modal").modal("show");
                    self.statusApprovedArr = [];
                    self.statusError = false;
                }
            }else{
                self.selectedStatus = "";
                self.vendorInvoiceIdArr = [];
                self.$swal('',"Please select Vendor Invoices with same status.",'info');
            }
        },
        hideVInvViewModal(){
            contex.vendorInvoiceId = "";
            contex.newWidth = '';
            contex.showPreview = false;
            contex.vendorInvPermission = [];
            $("#voucher-view-modal").modal("hide");
        },
        hideModal(){
            var self = this;
            $("#change-status-modal").modal("hide");
            self.selectedStatus = "";
            self.vendorInvoiceIdArr = [];

        },
        confirmStatus(flag,status,oldStatus){
            var self = this;
            if(self.ssArr.length > 1){
                self.selectedStatus = "";
                self.$swal('',"To change status, Please select records with same status.",'info');
                return;
            }else if(self.ssArr.length == 1){
                if(status == 'makePayment'){
                    self.makePayment();
                    return;
                }
            }
            var rowData = self.$refs['listBillTable'].selectedRows;
            for(var i = 0;i < rowData.length; i++){
                if(rowData[i].wo_status == "approved" && rowData[i].type == "sublet_invoice"){
                    if(status == 'approved'){
                    }else{
                        self.$swal('',"You cannot change the status because the work order has been already approved.",'info');
                        return;
                    }
                }
            }
            self.selectedStatus = oldStatus;
            console.log(oldStatus);
            console.log(self.selectedStatus);
            var newStatus = 'verified';
            newStatus = status;
            if (flag == "modal") {
                if (self.selectedStatus == 'entered') {
                    $("#verifyStatusBtn").prop("disabled", true);
                }else if (self.selectedStatus == 'verified') {
                    $("#approveStatusBtn").prop("disabled", true);
                    $("#disapproveStatusBtn").prop("disabled", true);
                }
                // else if (self.selectedStatus == 'disapproved') {
                //     $("#approveStatusBtn").prop("disabled", true);
                //     $("#voidStatusBtn").prop("disabled", true);
                // }
                $("#btnModalClose").prop("disabled", true);
            }else{
                if (self.selectedStatus == 'entered') {
                    $("#verifyStatusBtnPreview").prop("disabled", true);
                }else if (self.selectedStatus == '') {
                    $("#approveStatusBtnPreview").prop("disabled", true);
                    $("#disapproveStatusBtnPreview").prop("disabled", true);
                    $("#voidStatusBtnPreview").prop("disabled", true);
                }else if (self.selectedStatus == 'verified') {
                    $("#approveStatusBtnPreview").prop("disabled", true);
                    $("#disapproveStatusBtnPreview").prop("disabled", true);
                }
                // else if (self.selectedStatus == 'disapproved') {
                //     $("#approveStatusBtnPreview").prop("disabled", true);
                //     $("#voidStatusBtnPreview").prop("disabled", true);
                // }

            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/change-status",
                type: "POST",
                data: {arr:self.vendorInvoiceIdArr,status:newStatus,all:self.serverParams.selectedAll,currentflag:oldStatus,filters: self.serverParams.columnFilters},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (flag == "modal") {
                        if (self.selectedStatus == 'entered') {
                            $("#verifyStatusBtn").prop("disabled", false);
                        }else if (self.selectedStatus == 'verified') {
                            $("#approveStatusBtn").prop("disabled", false);
                            $("#disapproveStatusBtn").prop("disabled", false);
                        }
                        // else if (self.selectedStatus == 'disapproved') {
                        //     $("#approveStatusBtn").prop("disabled", false);
                        //     $("#voidStatusBtn").prop("disabled", false);
                        // }
                        $("#btnModalClose").prop("disabled", false);
                    }else{
                        if (self.selectedStatus == 'entered') {
                            $("#verifyStatusBtnPreview").prop("disabled", false);
                        }else if (self.selectedStatus == 'verified') {
                            $("#approveStatusBtnPreview").prop("disabled", false);
                            $("#disapproveStatusBtnPreview").prop("disabled", false);
                        }
                        // else if (self.selectedStatus == 'disapproved') {
                        //     $("#approveStatusBtnPreview").prop("disabled", false);
                        //     $("#voidStatusBtnPreview").prop("disabled", false);
                        // }
                    }

                    if (data.status == "success") {
                        if (flag == "verifyTab" || flag == "allTab") {

                            if (data.not_approved && data.not_approved.length > 0){

                                self.statusMessageError = true;
                                self.statusMessageApprovedArr = data.not_approved;
                                $("#seperate-message-modal").modal("show");
                            }else if (data.closed && data.closed.length > 0){
                                //Show Message if Vendor Invoice already attached to Line Item of Work Order and Work Order is closed
                                self.woClosedMessageError = true;
                                self.woClosedMessageArr = data.closed;
                                $("#work-order-message-modal").modal("show");
                            }else if (data.sub_system && data.sub_system.length > 0){
                            //Show Message if Sub System closed for Vendor Invoices on Approve
                                self.subSystemClosedMsgError = true;
                                self.subSystemClosedMsgArr = data.sub_system;
                                $("#sub-system-message-modal").modal("show");
                            }else if (data.doc_required && data.doc_required.length > 0){
                                self.docRequiredMsgError = true;
                                self.docRequiredMsgArr = data.doc_required;
                                $("#doc-required-message-modal").modal("show");
                            }else{
                                self.$swal('','Vendor Invoice Status Updated Successfully.','success');
                            }
                            self.loadList();
                        }else{
                            if (data.not_approved && data.not_approved.length > 0){

                                self.statusError = true;
                                self.statusApprovedArr = data.not_approved;

                            }else if (data.sub_system && data.sub_system.length > 0){
                            //Show Message if Sub System closed for Vendor Invoices on Approve
                                self.subSystemClosedMsgError = true;
                                self.subSystemClosedMsgArr = data.sub_system;
                                $("#sub-system-message-modal").modal("show");
                            }else if (data.doc_required && data.doc_required.length > 0){
                                self.docRequiredMsgError = true;
                                self.docRequiredMsgArr = data.doc_required;
                                $("#doc-required-message-modal").modal("show");
                            }else if (flag == "modal") {
                                self.hideModal();
                                self.$swal('','Vendor Invoices Status Updated Successfully.','success');
                            }else{
                                self.closeInvoicePreview();
                                self.$swal('','Vendor Invoice Status Updated Successfully.','success');
                            }
                            self.loadList();
                        }
                        console.log(data.batch);
                        console.log(data);
                        if (data.batch != undefined && data.batch != null){
                            self.statusBatchProcess = true;
                            self.importBatchId = data.batch;
                            self.importBatchNum = data.batchNumber;
                            self.checkBatchStatus();
                            self.loadList();
                        }

                    }else if(data.status == 'sublet_invoices'){
                        self.$swal('',"You cannot change the status because the work order has been already approved.",'info');
                        return;
                    }else{
                       if (data.closed && data.closed.length > 0){
                           //Show Message if Vendor Invoice already attached to Line Item of Work Order and Work Order is closed
                            self.woClosedMessageError = true;
                            self.woClosedMessageArr = data.closed;
                            $("#work-order-message-modal").modal("show");
                        }else if (data.sub_system && data.sub_system.length > 0){
                           //Show Message if Sub System closed for Vendor Invoices on Approve
                            self.subSystemClosedMsgError = true;
                            self.subSystemClosedMsgArr = data.sub_system;
                            $("#sub-system-message-modal").modal("show");
                        }else if (data.doc_required && data.doc_required.length > 0){
                            self.docRequiredMsgError = true;
                            self.docRequiredMsgArr = data.doc_required;
                            $("#doc-required-message-modal").modal("show");
                        }
                    }
                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status');
                }
            });
        },
        openInvoicePreview(id,status,verify_by,file_path,extension) {
            var self = this;
            self.extension = extension;
            self.path = file_path;
            self.vendorInvoiceIdArr = [];
            self.vendorInvoiceIdArr.push(id);
            self.selectedStatus = status.toLowerCase();
            if (verify_by == self.loggedInUser){
                self.isVerifiedBy = true;
            }else{
                self.isVerifiedBy = false;
            }
            $( "#invoice-detail-section" ).animate({
                right: "0px",
            }, 300 );


        },
        closeInvoicePreview(){
            var self = this;
            $( "#invoice-detail-section" ).animate({
                right: "-900px",
            }, 300 );
            self.selectedStatus = "";
            self.vendorInvoiceIdArr = [];
            self.path = "";
            self.extension = "";
        },

      closePrintPreview(){
        var self = this;
        self.pdfContent = [];
      },

        selectionChanged:function(param){
            var self = this;

            var rowData = self.$refs['listBillTable'].selectedRows;
            var statusArr = [];
            var dStatusArr = ['entered','verified','approved','paid'];
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            self.showPaymentBtn = false;
            self.isVerifiedBy = false;
            // self.displayConfirmBtn = false;
            // self.displayPrintBtn = false;
            // self.displayResetBtn = false;
            self.isNotVerifiedBy = false;
            self.vendorInvoiceIdArr = [];
            self.ssArr = [];

            self.bool_enter=false;
            self.bool_verify=false;
            self.bool_approve=false;
            self.bool_disapprove=false;
            self.bool = false;
            if ( rowData.length > 0){
                for(var i = 0; i < rowData.length; i++){

                    if (rowData[i].verified_by == self.loggedInUser){
                        self.isVerifiedBy = true;
                    }

                    if (rowData[i].verified_by != self.loggedInUser){
                        self.isNotVerifiedBy = true;
                    }
                    if(rowData[i].status == 'Void'){
                      self.$swal('',"Vendor Invoices with Void status cannot be changed.",'info');
                      return;
                    }
                    // if(rowData[i].status == 'In Progress'){
                    //   self.displayConfirmBtn = true;
                    //   // self.$swal('',"Vendor Invoices with In Progress status cannot be changed.",'info');
                    //   // return;
                    // } else {
                    //   self.displayConfirmBtn = false;
                    // }
                    // if(rowData[i].status == 'Confirmed'){
                    //   self.displayPrintBtn = true;
                    // } else {
                    //   self.displayPrintBtn = false;
                    // }
                    // if(rowData[i].status == 'Paid'){
                    //   self.displayResetBtn = true;
                    // } else {
                    //   self.displayResetBtn = false;
                    // }
                    statusArr.push(rowData[i].status);
                    self.vendorInvoiceIdArr.push(rowData[i].id);
                }

                for (let i = 0; i < dStatusArr.length; i++) {
                    for (let j = 0; j < statusArr.length; j++) {
                      if (dStatusArr[i] == statusArr[j].toLowerCase()) {
                        self.ssArr.push(statusArr[j].toLowerCase());
                        break;
                      }
                    }
                }console.log(self.vendorInvoiceIdArr.length+"---"+self.ssArr);
                if(self.ssArr.includes('entered')){
                  self.bool_enter = true;
                }
                if(self.ssArr.includes('approved')){
                  self.bool_approve = true;
                }

                if(self.ssArr.includes('verified') && self.ssArr.includes('entered')){
                  self.bool = true;
                }else{
                  if(self.ssArr.includes('entered')){
                    self.bool_disapprove = true;
                  }
                  if(self.ssArr.includes('verified')){
                    self.bool_verify = true;
                  }
                }
                // for(let i = 0; i < self.ssArr.length; i++){
                //   self.selectedStatus = self.ssArr[i];
                // }console.log(self.selectedStatus);

                //check all values in array are equal or not
                // const allEqual = arr => arr.every( v => v === arr[0] );
                // var found = allEqual(statusArr);
                // if ( found ) {
                //     self.selectedStatus = statusArr[0].toLowerCase();
                    //show make payment button only if status is approved
                    // if ( self.selectedStatus == "approved" ) {
                    //     self.showPaymentBtn = true;
                    // }
                    // if(self.selectedStatus == 'void') {
                    //     self.selectedStatus = "";
                    //     self.vendorInvoiceIdArr = [];
                    //     self.$swal('',"Vendor Invoices with Void status cannot be changed.",'info');
                    // }else if(self.selectedStatus == 'in progress') {
                    //     self.selectedStatus = "";
                    //     self.vendorInvoiceIdArr = [];
                    //     self.$swal('',"Vendor Invoices with In Progress status cannot be changed.",'info');
                    // }
              //   }
              //   else{


              //       self.selectedStatus = "";
              //       self.vendorInvoiceIdArr = [];
              //       self.$swal('',"To change status, Please select records with same status.",'info');
              //  }
            }
            if(self.ssArr.includes('approved') && rowData.length > 0)
            {
                self.sendInvButton = true;
            }else if(self.ssArr.includes('paid') && rowData.length > 0){
                self.sendInvButton = true;
            }
            else{
                self.sendInvButton = false;
            }
        },
     /*   reset() {

          var self = this;

          // var data = self.$refs['listBillTable'].selectedRows;
          // var use = [];
          // for (var i = 0; i < data.length; i++) {
          //     use.push(self.$refs['listBillTable'].selectedRows[i].payment_id)
          // }

          self.confirmInvoiceStatus('void');

        },*/
        /*print(el) {

            var self = this;

            var message = '';
            // if (self.status == 'Printed' || self.status == 'printed'){

            //     message = 'Check already printed';
            // } else {
                message = 'Once You print the Check the Check number will not be used again';
            // }

            // if (self.flagAll == ''){
                if (window.confirm(message)){
                  // if(self.status == 'confirmed') {
                    // self.confirmInvoiceStatus('printed');
                    self.loadCheckData();
                  // }

                  // var restorepage = $('body').html();
                  // $('body').empty().html(self.contentHtml);
                  // window.print();
                  // $('body').html(restorepage);
                }
            // }
            // else{
            //       var restorepage = $('body').html();
            //       // var printcontent = $('#' + el).clone();
            //       // var enteredtext = $('#text').val();
            //       $('body').empty().html(self.contentHtml);
            //       window.print();
            //       $('body').html(restorepage);
            // }

        }, */
        loadCheckData() {
            var self = this;
            self.loading = true;

            var data = self.$refs['listBillTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(self.$refs['listBillTable'].selectedRows[i].payment_id)
            }

            $.ajax({
                url: process.env.ROOT_API + "/payment-check/preview",
                type: "GET",
                data: {
                    payment_id: '',
                    flag:'all',
                    paymentIdArr:use.join()
                },
                crossDomain: true,
                dataType:'json',
                headers: this.ajxHeaders,
                // dataType: "html",
                success: function (data) {
                    self.loading = false ;
                    if (self.flagAll == ''){

                        // setTimeout(function(){

                        //     $("#print_payment_cheque").html("");
                        //     setTimeout(function(){
                        //         $("#print_payment_cheque").html(data.print_content);
                        //     },200);
                        // },500);
                        // self.status = data.payment_status;
                        var contentHtml = data.print;
                         var restorepage = $('body').html();
                        // var printcontent = $('#' + el).clone();
                        // var enteredtext = $('#text').val();
                        $('body').empty().html(contentHtml);
                        window.print();
                        $('body').html(restorepage);
                    }else{
                        // self.viewArr = data.content;
                        var restorepage = $('body').html();
                        var contentHtml = data.print_content;
                        $('body').empty().html(contentHtml);
                        window.print();
                        $('body').html(restorepage);
                    }


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'payment-check-preview');
                }
            });
        },
        confirmInvoiceStatus : function(status){
            var self = this;

            var data = self.$refs['listBillTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(self.$refs['listBillTable'].selectedRows[i].payment_id)
            }
            var fields = {
                arr:use,
                status:status,
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-payment/change-status",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.status = 'confirmed';
                        self.$swal('','Vendor Payment Confirmed Successfully.','success');
                        self.loadList();
                    }
                },
                error: function (jqXHR, exception) {
                    if (flag == "list") {
                        $("#confirmPaymentBtn").prop("disabled", false);
                        $("#deletePaymentBtn").prop("disabled", false);
                    }else if (flag == "reason") {
                        $("submitReasonBtn").prop("disabled",false);

                    }else{
                        $("#confirmStatusBtnPreview").prop("disabled", false);
                        $("#cancelStatusBtnPreview").prop("disabled", false);
                    }
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'payment-check-change-status');
                }
            });
        },
        makePayment() {
            var self = this;
            self.vendorInvoiceIdArr = [];
            var PaymentArr = [];
            var rowData = self.$refs['listBillTable'].selectedRows;
            for(var i = 0; i < rowData.length; i++){
                self.vendorInvoiceIdArr.push(rowData[i].id);
                if(rowData[i].payment_type == 'CREDIT CARD'){
                  self.$swal('',"Please select records with PaymentType - ACH, CHECK or COMCHECK.",'info');
                  return;
                }
                if(rowData[i].payment_type == undefined || rowData[i].payment_type == ""){
                  self.$swal('',"PaymentType cannot be empty.",'info');
                  return;
                }
                //check whether payment amount is less than zero
                if (rowData[i].amount != undefined && rowData[i].amount != null) {
                    var invoiceAmt = rowData[i].amount;
                    invoiceAmt = invoiceAmt.replace("$","");
                    invoiceAmt = invoiceAmt.replace(",","");
                    if (Number(invoiceAmt) < 0) {
                        self.$swal('',"Payment Amount cannot be less than zero.",'info');
                        return;
                    }
                }
                if (rowData[i].payment_type != "") {
                    PaymentArr.push(rowData[i].payment_type);
                }
            }
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(PaymentArr);
            if ( found ) {
              //set payment type from payment type arr

              self.check_number = "";

              if (PaymentArr[0] == "CHECK") {
                let obj = self.paymentTypesArr.find(o => o.code === 'CH');
                self.payment_type = {text:PaymentArr[0],value:obj.value,code:obj.code};

                self.check_number = self.checknumber;

              }else{

                // self.check_number = self.checknumber;
                  let obj = self.paymentTypesArr.find(o => o.code === PaymentArr[0]);
                  if(obj.code == "ACH") {
                    self.check_number = self.ach_check_number;
                  } else {
                    self.check_number = self.checknumber;
                  }
                  self.payment_type = {text:PaymentArr[0],value:obj.value,code:obj.code};
              }
              $("#make-payment-modal").modal("show");
            } else {
              self.$swal('',"Please select records with similar PaymentType.",'info');
            }

        },
        hidePaymentModal() {
            var self = this;
            $("#make-payment-modal").modal("hide");
            self.payment_type_error_msg = "";
            self.payment_type = "";
            self.vendorInvoiceIdArr = [];
            self.showTagSearchField = true;
            self.payment_tag = "";
            self.tag_input = "";
            self.tag_input_error_msg = "";
            self.payment_date = "";
            self.payment_date_error_msg = "";
        },
        processPayment() {
            var self = this;
            var error = false;
            self.payment_type_error_msg = "";
            self.payment_date_error_msg = "";

            if (!self.payment_type || self.payment_type == null || self.payment_type == "") {
                self.payment_type_error_msg = "Payment Type Required.";
                error = true;
            }

            if (self.payment_date == "" || self.payment_date == null) {
                self.payment_date_error_msg = "Payment Date Required.";
                error = true;
            }

            if (!error) {

                $("#btnPaymentModalProcess").prop("disabled", true);
                $("#btnPaymentModalCancel").prop("disabled", true);
                $("#btnPaymentModalClose").prop("disabled", true);

                self.loading = true;
                if ( self.payment_tag != null && self.payment_tag.value != "" ) {
                    var fields = {
                        arr:self.vendorInvoiceIdArr,
                        payment_type:self.payment_type.value,
                        payment_tag:self.payment_tag.value,
                        flag:self.payment_type.code,
                        payment_date:self.payment_date,
                    }
                }else{
                    var fields = {
                        arr:self.vendorInvoiceIdArr,
                        payment_type:self.payment_type.value,
                        payment_tag:"",
                        flag:self.payment_type.code,
                        payment_date:self.payment_date
                    }
                }

                $.ajax({
                    url: process.env.ROOT_API + "/vendor-invoice/process-payment",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        $("#btnPaymentModalProcess").prop("disabled", false);
                        $("#btnPaymentModalCancel").prop("disabled", false);
                        $("#btnPaymentModalClose").prop("disabled", false);

                        if (data.status == "success") {

                            self.hidePaymentModal();
                            self.$swal('','Vendor Invoices Processed For Payment Successfully.','success');
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-process-payment');
                    }
                });
            }
        },
        showTagInput() {
            var self = this;
            self.showTagSearchField = false;
            self.tag_input_error_msg = "";
        },
        onSearchPaymentTag(search, loading) {
            var self = this;
            if (search.length > 1) {
                loading(true);
                self.searchField(loading, search, 'payment tags', '');
            }
        },
        savePaymentTag() {
            var self = this;
            var error = false;
            self.tag_input_error_msg = "";

            if(self.tag_input == "" || !self.tag_input){
                self.tag_input_error_msg = "Tag Name Required.";
                error = true;
            }

            if(self.tag_input.trim() == ""){
                self.tag_input_error_msg = "Tag Name Required.";
                error = true;
            }

            if (!error) {
                self.loading = true;
                $("#btnSaveTagModal").prop("disabled",true);
                $.ajax({
                    url: process.env.ROOT_API + "/payment-tag/create",
                    type: "POST",
                    data: {tag_name:self.tag_input},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $("#btnSaveTagModal").prop("disabled",false);
                        if (data.status == "success") {
                            console.log(data.content.text);
                            console.log(data.content.value);
                            self.payment_tag = {
                                text:data.content.text,
                                value:data.content.value
                            };
                            self.showTagSearchField = true;
                            self.tag_input = "";
                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.tag_input_error_msg += data.content[i] + "\n";
                                }

                                setTimeout(function () {
                                    self.tag_input_error_msg = "";
                                }, 5000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#btnSaveTagModal").prop("disabled",false);
                        self.generateStatusCodeMessage(jqXHR,true,'payment-tag-create');
                    }
                });
            }

        },
        getAllVendorInvoices() {
            var self = this;
            self.allActive = 'active';
            self.verifiedActive = '';
            self.approvedActive = '';
            self.enteredActive = '';
            self.deletedActive = '';
            self.paidActive = '';
            self.flag = 'all';
            localStorage.setItem('bill_list_prev_tab', 'all');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        getVerifiedVendorInvoices() {
            var self = this;
            self.allActive = '';
            self.verifiedActive = 'active';
            self.approvedActive = '';
            self.enteredActive = '';
            self.deletedActive = '';
            self.paidActive = '';
            self.flag = 'verified';
            localStorage.setItem('bill_list_prev_tab', 'verified');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        getEnteredVendorInvoices() {
            var self = this;
            self.allActive = '';
            self.verifiedActive = '';
            self.approvedActive = '';
            self.enteredActive = 'active';
            self.flag = 'entered';
            self.deletedActive = '';
            self.paidActive = '';
            localStorage.setItem('bill_list_prev_tab', 'entered');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        getApprovedVendorInvoices() {
            var self = this;
            self.allActive = '';
            self.verifiedActive = '';
            self.approvedActive = 'active';
            self.enteredActive = '';
            self.flag = 'approved';
            self.deletedActive = '';
            self.paidActive = '';
            localStorage.setItem('bill_list_prev_tab', 'approved');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        getDeletedVendorInvoices() {
            var self = this;
            self.allActive = '';
            self.verifiedActive = '';
            self.approvedActive = '';
            self.enteredActive = '';
            self.flag = 'deleted';
            self.deletedActive = 'active';
            self.paidActive = '';
            localStorage.setItem('bill_list_prev_tab', 'deleted');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        getPaidVendorInvoices() {
            var self = this;
            self.allActive = '';
            self.verifiedActive = '';
            self.approvedActive = '';
            self.enteredActive = '';
            self.flag = 'paid';
            self.deletedActive = '';
            self.paidActive = 'active';
            localStorage.setItem('bill_list_prev_tab', 'paid');
            //clear filters and load list
            self.$refs.filterBill.onColumnFilter('cancel');
            self.loadList();
        },
        hideMessageModal() {
            var self = this;
            self.statusMessageError = false;
            self.statusMessageApprovedArr = [];
            $("#seperate-message-modal").modal("hide");
        },
        openInvoicePreviewTab(vendorInvoiceId, event) {
            var self = this;

            contex.vendorInvoiceId = "";
            contex.newWidth = '';
            contex.showPreview = false;
            contex.vendorInvPermission = [];

            self.vendorInvPermission = self.permissions;
            self.vendorInvoiceId = vendorInvoiceId;
            //self.newWidth = 'width-50 fix-height';
            self.showPreview = true;
            $('#voucher-view-modal').modal('show');

        },
        openPdfPrintTab(vendorInvoiceId){
          var self = this;
          self.vendorInvoiceId = vendorInvoiceId;
          self.showPreview = true;
          self.loadPdfPreview('load', vendorInvoiceId)
          // $('#print-pdf-modal').modal('show');
        },
        onFileChanged (event) {
            const file = event.target.files[0]
            console.log(event.target);
            var self = this;
            self.selectedBillFile = file;
            self.notfound = false;
            self.notFoundArr = [];
            console.log(self.selectedBillFile);
        },
        openModal: function(){
            var self = this;
            if (self.importBatchProcess){
                self.$swal('','Previous batch already runnig','info');
                return;
            }
            self.selectedBillFile = "";
            self.selectedFileErrorMsg = "";
            self.duplicateInvoice = [];
            self.dateIssueInvoice = [];
            self.withoutVendorInvoice = [];
            self.dateValidateInvoice = [];
            self.dateValidateCount = 0;
            self.duplicateInvCount = 0;
            self.dateIssueCount = 0;
            self.withoutVendorCount = 0;
            $("#typeImage").val('');

            $.ajax({
                url:
                process.env.ROOT_API + "/bill-excel/generate",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    console.log(data);
                    self.fileName = data.content.file;
                    self.file = data.content.web;

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'permit-import')

                }
            });

            $('#myModal').modal('show');
        },
        downloadSample(){
            var self = this;
            // alert(self.file);
            // console.log()
            var docPath = self.file;
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },
        importBill: function(){
            var self = this;
            var error = false;
            self.selectedFileErrorMsg = "";

            if (self.selectedBillFile == "" || self.selectedBillFile == null) {
                self.selectedFileErrorMsg = "File Required.";
                error = true;
            }

            if (!error) {
                var formData = new FormData();
                formData.append('myFile', self.selectedBillFile);

                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/bill/import",
                    type: "POST",
                    // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        $('#myButton').text('Import');
                        $('#myButton').prop('disabled',false);
                        self.loading = false;
                        if (data.content.batch_id != undefined && data.content.batch_id != null){
                            self.importBatchProcess = true;
                            self.importBatchId = data.content.batch_id;
                            self.importBatchNum = data.content.batch;
                            self.checkBatchStatus();
                            $('#myModal').modal('hide');
                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#myButton').text('Import');
                        $('#myButton').prop('disabled',false);
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')
                    }
                });
            }


        },
        hideWOMessageModal() {
            var self = this;
            self.woClosedMessageError = false;
            self.woClosedMessageArr = [];
            $("#work-order-message-modal").modal("hide");
        },
        hideSubSystemMessageModal() {
            var self = this;
            self.subSystemClosedMsgError = false;
            self.subSystemClosedMsgArr = [];
            $("#sub-system-message-modal").modal("hide");
        },
        showAssigneeModal() {
            var self = this;
            self.change_assignee = "";
            self.assignee_error_msg = "";
            self.assigneeArr = [];
            self.billIdArr = [];
            var billStatusArr = [];
            var billWithPayment = false;
            var statusMsg = "";
            var rowData = self.$refs['listBillTable'].selectedRows;
            for(var i = 0; i < rowData.length; i++){
                self.billIdArr.push(rowData[i].id);
                //check whether payment done against voucher or not
                if (rowData[i].payment_id != null) {
                    if (!billWithPayment) {
                        billWithPayment = true;
                        if (rowData[i].status != undefined && rowData[i].status != null) {
                            if (!billStatusArr.includes(rowData[i].status)) {
                                billStatusArr.push(rowData[i].status);
                                if (statusMsg == "") {
                                    statusMsg = rowData[i].status;
                                }else{
                                    statusMsg += " | ";
                                    statusMsg += rowData[i].status;
                                }
                            }
                        }
                    }
                }
            }
            if (!billWithPayment) {
                $("#change-assignee-modal").modal("show");
            }else{
                var errorMsg = "Assignee cannot be changed for Vendor Invoice with Payment Number.";
                if (statusMsg != "") {
                    errorMsg = "Assignee cannot be changed for Vendor Invoice with status " + statusMsg + ".";
                }
                self.$swal('',errorMsg,'info');
                return;
            }
        },
        hideAssigneeModal() {
            var self = this;
            self.change_assignee = "";
            self.assignee_error_msg = "";
            self.assigneeArr = [];
            self.billIdArr = [];
            $("#change-assignee-modal").modal("hide");
        },
        onSearchAssignee(search, loading) {
            var self = this;
            self.assignee_error_msg = "";
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'bill_vendor', '');
            }
        },
        changeAssignee() {
            var self = this;
            var error = false;
            console.log("assignee ==", self.change_assignee);
            console.log("payment ==", self.change_paymenttype);
            self.assignee_error_msg = "";
            if (self.change_assignee == null || !self.change_assignee.value) {
              console.log("payment1 ==", self.change_paymenttype);

              if (self.change_paymenttype == null || self.change_paymenttype == "") {
                console.log("payment2 ==", self.change_paymenttype);

                  self.paymenttype_error_msg = "Payment Type Required.";
                  // error = true;

                  self.assignee_error_msg = "Assignee Required.";
                  error = true;
              }

            }

            var paymentType = "";

            self.paymenttype_error_msg = "";
            if (self.change_paymenttype == null || self.change_paymenttype == "") {
              console.log("payment3 ==", self.change_paymenttype);

              if (self.change_assignee == null || !self.change_assignee.value) {

                self.paymenttype_error_msg = "Payment Type Required.";
                self.assignee_error_msg = "Assignee Required.";
                error = true;

              }

            } else {

              paymentType = self.change_paymenttype.value;

            }

            var billVendorArr = [];
            var voucherArr = [];
            var rowData = self.$refs['listBillTable'].selectedRows;
            var assignee = "";
            for(var i = 0; i < rowData.length; i++){
                if (rowData[i].vendor_id != undefined && rowData[i].vendor_id != null) {
                    billVendorArr.push(rowData[i].vendor_id);
                    voucherArr.push({
                        id:rowData[i].id,
                        voucher:rowData[i].voucher_number,
                        vendor_id:rowData[i].vendor_id
                    })
                }
            }

            //check whether assignee added as vendor in selected vouchers
            if (self.change_assignee != null) {
                if (self.change_assignee.value != null) {
                  assignee = self.change_assignee.value;
                    if (billVendorArr.includes(self.change_assignee.value)) {
                        var voucherMsg = "";
                        for(var i = 0;i < voucherArr.length;i++) {
                            if (voucherArr[i].vendor_id != undefined && voucherArr[i].vendor_id != null) {
                                if (voucherArr[i].vendor_id == self.change_assignee.value) {
                                    if (voucherArr[i].voucher != undefined && voucherArr[i].voucher != null) {
                                        if (voucherMsg == "") {
                                            voucherMsg = voucherArr[i].voucher;
                                        }else{
                                            voucherMsg += " | ";
                                            voucherMsg += voucherArr[i].voucher;
                                        }
                                    }
                                }
                            }
                        }
                        var errorMsg = "Assignee already added as vendor";
                        if (voucherMsg != "") {
                            errorMsg += " in voucher ";
                            errorMsg += voucherMsg;
                            self.assignee_error_msg = errorMsg;
                            error = true;
                        }
                    }
                }
            }

            if (!error) {
                self.loading = true;
                $("#btnAssigneeModalUpdate").prop('disabled',true);
                $("#btnAssigneeModalCancel").prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/voucher-assignee/update",
                    type: "POST",
                    data: {
                      id:self.billIdArr,
                      assignee: assignee, //self.change_assignee.value
                      payment_type: paymentType
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $("#btnAssigneeModalUpdate").prop('disabled',false);
                        $("#btnAssigneeModalCancel").prop('disabled',false);
                        if (data.status == "success") {
                            self.$swal('', data.message,'success');
                            // 'Vendor Invoice Assignee Updated Successfully.'
                            self.action = "list";
                            self.loadList();
                            self.hideAssigneeModal();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#btnAssigneeModalUpdate").prop('disabled',false);
                        $("#btnAssigneeModalCancel").prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'change-assignee-err');
                    }
                });
            }
        },
        checkBatchStatus:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.importBatchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;
                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.importBatchProcess = false;
                        self.remittanceBatchProcess = false;
                        self.statusBatchProcess = false;
                        self.batchSuccess = true;
                        setTimeout(function(){
                            self.batchSuccess = false;
                        },4000);
                        if (data.other_params != undefined && data.other_params != null && data.other_params != "") {
                            self.errorLink = data.other_params;
                            self.errorFound = true;
                        }else{
                            self.errorLink = "";
                            self.errorFound = false;
                        }
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.importBatchProcess = false;
                        self.remittanceBatchProcess = false;
                        self.errorFound = false;
                        self.errorLink = "";
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });
            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });
        },
        hideDocRequireModal() {
            var self = this;
            self.docRequiredMsgError = false;
            self.docRequiredMsgArr = [];
            $("#doc-required-message-modal").modal("hide");
        },
        loadPdfPreview(value, ids) {
            var self = this;
            var fields = {};
            var error = false;
            self.dataFound = "";

            if (!error) {
            self.loading = true;

            fields = {
                flag: "load",
                ids: ids,
                action: 'single'
            }

            if (ids.length > 1) {
                if(ids.length > process.env.EXPORT_PDF){
                self.action = 'batch'
                fields = {
                    flag: "load",
                    ids: ids,
                    action: 'batch'
                }
                alert("Total records are more than "+ process.env.EXPORT_PDF + ", So your file will be scheduled in queue. You can download it from batch screen once it will be completed.")
                }
                $.ajax({
                url: process.env.ROOT_API + "/vendor-invoice/multiple-pdf",
                type: "POST",
                headers: this.ajxHeaders,
                data: fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status === "success") {
                        self.$refs.filterBill.clearSelectAll();
                        self.batchNum = data.content;
                    if (self.action == "list") {
                        window.open(data.content, '_blank');
                    } else {
                        self.batchProcess = 1;
                        self.batchNum = data.content.batch.id;
                    }

                    }
                },
                error: function (jqXHR) {
                    self.loading = false;
                    if (value === "previous" || value === "next") {
                    $("#previousBtn").prop("disabled", false);
                    $("#nextBtn").prop("disabled", false);
                    }
                    self.generateStatusCodeMessage(jqXHR, false, 'pdf-print-view');
                }
                });
            } else {
                fields = {
                flag: "load",
                id: ids[0],
                action: 'single'
                }

                $.ajax({
                url: process.env.ROOT_API + "/vendor-invoice/preview",
                type: "POST",
                headers: this.ajxHeaders,
                data: fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    window.open(data.content.file_path, '_blank');
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (value === "previous" || value === "next") {
                    $("#previousBtn").prop("disabled", false);
                    $("#nextBtn").prop("disabled", false);
                    }
                    self.generateStatusCodeMessage(jqXHR, false, 'pdf-print-view');
                }
                });
            }
            }
        },
        sendInvoices(flag) {
            var self = this;
            self.invArr = [];
            var rowData = self.$refs['listBillTable'].selectedRows;

                for (var i = 0;i <rowData.length;i++) {
                    if(this.$refs['listBillTable'].selectedRows[i].vendorname == null || this.$refs['listBillTable'].selectedRows[i].vendorname == ''){
                        if (!self.invArr.some(e => e.vendor_id === this.$refs['listBillTable'].selectedRows[i].vendor_id)) {
                            self.invArr.push({vendorname: this.$refs['listBillTable'].selectedRows[i].vendorname,vendor_id: this.$refs['listBillTable'].selectedRows[i].vendor_id})
                        }
                    }
                }

            if(self.invArr.length != 0){
                $("#vendor-view-modal").modal("show");
            }else{
                self.action="sendRemittance";
                self.loadList();
            }
            if(flag == 'done'){
                self.action="sendRemittance";
                $("#vendor-view-modal").modal("hide");
                self.loadList();
            }
        },
        //get count of status like verified,approved,all
        getcount(){
            console.log("here get count");
            var self = this;
            var fields = {
                flag:self.flag,
            };
            // self.loading = true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/bill/count",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                success: function (data) {
                    if (data.status == "success") {
                        self.filteredFlag = false;
                        //check selected flag status
                        if(data.flag == "verified"){
                            self.allCount = data.content.allCount;
                            self.approvedCount = data.content.approvedCount;
                            self.enteredCount = data.content.enteredCount;
                            self.verifiedCount = data.content.verifiedCount;
                            self.deletedCount = data.content.deletedCount;
                            self.paidCount = data.content.paidCount;
                        }else if (data.flag == "approved"){
                            self.allCount = data.content.allCount;
                            self.approvedCount = data.content.approvedCount;
                            self.verifiedCount = data.content.verifiedCount;
                            self.enteredCount = data.content.enteredCount;
                            self.deletedCount = data.content.deletedCount;
                            self.paidCount = data.content.paidCount;
                        }else if (data.flag == "entered"){
                            self.allCount = data.content.allCount;
                            self.verifiedCount = data.content.verifiedCount;
                            self.approvedCount = data.content.approvedCount;
                            self.enteredCount = data.content.enteredCount;
                            self.deletedCount = data.content.deletedCount;
                            self.paidCount = data.content.paidCount;
                        }else if (data.flag == "deleted"){
                            self.allCount = data.content.allCount;
                            self.verifiedCount = data.content.verifiedCount;
                            self.approvedCount = data.content.approvedCount;
                            self.enteredCount = data.content.enteredCount;
                            self.deletedCount = data.content.deletedCount;
                            self.paidCount = data.content.paidCount;
                        }else{
                            self.verifiedCount = data.content.verifiedCount;
                            self.approvedCount = data.content.approvedCount;
                            self.enteredCount = data.content.enteredCount;
                            self.allCount = data.content.allCount;
                            self.deletedCount = data.content.deletedCount;
                            self.paidCount = data.content.paidCount;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.action = "list";
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-list');
                }
            });
        },
        //add conform invioce in conform_bill table and redirect to ConformBillList page
        conforminvoice(){
            var self = this;
            // var statusArr = [];
            self.vendorInvoiceIdArr = [];
            var data = this.$refs['listBillTable'].selectedRows;
            for(var i = 0;i < data.length; i++){
                self.vendorInvoiceIdArr.push(data[i].id);
                // statusArr.push(data[i].status);
                console.log(data[i].status);
                var status = data[i].status.toLowerCase()
                if(status != 'approved'){
                    self.$swal('',"Please select records with status approved.",'info');
                  return;
                }
            }

            //check all values in array are equal or not
            // const allEqual = arr => arr.every( v => v === arr[0] );
            // var found = allEqual(statusArr);
            // if (found) {
            //     self.selectedStatus = statusArr[0].toLowerCase();

            //     if (self.selectedStatus != 'approved') {
            //         self.selectedStatus = "";
            //         self.vendorInvoiceIdArr = [];
            //         self.$swal('',"Please select records with status approved.",'info');
            //         return;
            //     }
            // }
            var value = [];
            for (var i = 0; i < data.length; i++) {
                value.push({bill_date: this.$refs['listBillTable'].selectedRows[i].bill_date,id: this.$refs['listBillTable'].selectedRows[i].id})
            }
            var fields = {
                value: value,
            };
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/conforminvoice",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                crossDomain: true,
                success: function (data) {
                    self.loading = false;
                    self.loadList();
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.action = "list";
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-list');
                }
            });
        },
        oninviceFileChanged (event) {
            const approvfile = event.target.files[0]
            console.log(event.target);
            var self = this;
            self.selectedapproveBillFile = approvfile;
            self.notfound = false;
            self.notFoundArr = [];
            console.log(self.selectedapproveBillFile);
        },
        //open approved invoice model
        openApprovedInvoicesModal: function(){
            var self = this;
            if (self.importBatchProcess){
                self.$swal('','Previous batch already runnig','info');
                return;
            }
            self.selectedapproveBillFile = "";
            self.selectedapproveFileErrorMsg = "";

            $("#type_Image").val('');

            $.ajax({
                url:
                process.env.ROOT_API + "/vendor-bill-excel/generate",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    self.file_Name = data.content.file;
                    self.file = data.content.web;
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'permit-import')

                }
            });
            $('#myapprovedModal').modal('show');
        },
        // import approved invoices
        importApprovedInvoices: function(){
            var self = this;
            var error = false;
            self.selectedapproveFileErrorMsg = "";

            if (self.selectedapproveBillFile == "" || self.selectedapproveBillFile == null) {
                self.selectedapproveFileErrorMsg = "File Required.";
                error = true;
            }

            if (!error) {
                var formData = new FormData();
                formData.append('myFile', self.selectedapproveBillFile);
                formData.append('flag', "verified");

                self.loading = true;
                $('#myapproveButton').text('Fetching...');
                $('#myapproveButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-confirm-bill/import",
                    type: "POST",
                    // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.invalid_data = [];
                        $('#myapproveButton').text('Import');
                        $('#myapproveButton').prop('disabled',false);
                        self.loadList();
                        self.loading = false;
                        $('#myapprovedModal').modal('hide');
                        if(data.content.length > 0){
                          self.invalid_data = data.content;
                          $('#validationModal').modal('show');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loadList();
                        $('#myapproveButton').text('Import');
                        $('#myapproveButton').prop('disabled',false);
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')
                    }
                });
            }


        },

    }
}

EventBus.$on('close_vendor_invoice_preview',function() {
    contex.vendorInvoiceId = "";
    contex.newWidth = '';
    contex.showPreview = false;
});
</script>
<style scoped>
.page-title.venderinvoice{
    width: 35% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/BillList.vue